import { z } from 'zod'

export const ProjectEditorSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
})

export type ProjectEditor = z.infer<typeof ProjectEditorSchema>
